import API from "./API";
const accessToken = localStorage.getItem("hrms_employee_auth");

const GeneralService = {
    //Get
    apiGetCallRequest: function (url) {
        return new Promise((resolve, reject) => {
            API.get(`${url}`, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${accessToken}`,
                },
            })
                .then((res) => resolve(res.data))
                .catch((error) => reject(error));
        });
    },
    //Post
    apiPostCallRequest: function (url, body = null) {
        return new Promise((resolve, reject) => {
            API.post(`${url}`, body, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${accessToken}`,
                },
            })
                .then((res) => resolve(res.data))
                .catch((error) => reject(error));
        });
    },
    //Post bolb for file/pdf
    apiPostBolbCallRequest: function (url, body = null) {
        return new Promise((resolve, reject) => {
            API.post(`${url}`, body, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${accessToken}`,
                },
                responseType: 'arraybuffer'//'blob'
            })
                .then((res) => resolve(res.data,))
                .catch((error) => reject(error));
        });
    },
    //Delete
    apiDeleteCallRequest: function (url, params) {
        return new Promise((resolve, reject) => {
            API.delete(`${url}` + params, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${accessToken}`,
                },
            })
                .then((res) => resolve(res.data))
                .catch((error) => reject(error));
        });
    },
    //Put
    apiPutCallRequest: function (url, params) {
        return new Promise((resolve, reject) => {
            API.put(`${url}`, params, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${accessToken}`,
                },
            })
                .then((res) => resolve(res.data))
                .catch((error) => reject(error));
        });
    },
    //FormData
    apiPostCallFormDataRequest: function (url, body = null) {
        //console.log(url);
        return new Promise((resolve, reject) => {
            API.post(`${url}`, body, {
                headers: {
                    "Content-Type": "application/form-data",
                    Authorization: `Bearer ${accessToken}`,
                },
            })
                .then((res) => resolve(res.data))
                .catch((error) => reject(error));
        });
    },



    //Get Without Token
    apiGetCallRequestWithoutToken: function (url) {
        return new Promise((resolve, reject) => {
            API.get(`${url}`, {
                headers: {
                    "Content-Type": "application/json",
                },
            })
                .then((res) => resolve(res.data))
                .catch((error) => reject(error));
        });
    },
    //Post Without Token
    apiPostCallRequestWithoutToken: function (url, body = null) {
        return new Promise((resolve, reject) => {
            API.post(`${url}`, body, {
                headers: {
                    "Content-Type": "application/json",
                },
            })
                .then((res) => resolve(res.data))
                .catch((error) => reject(error));
        });
    },


      //Post FormData Without Token
      apiPostCallFormDataRequestWithoutToken: function (url, body = null) {
        return new Promise((resolve, reject) => {
            API.post(`${url}`, body, {
                headers: {
                    "Content-Type": "application/form-data",
                },
            })
                .then((res) => resolve(res.data))
                .catch((error) => reject(error));
        });
    },
};
export default GeneralService;


export async function apiPostBolbPdfCallRequest(url, body = null) {
    return await fetch(`${url}`, {
        method: 'POST',
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
        },
        responseType: 'arraybuffer',//'blob',
        body: body
    }).then(response => response.json())
        .then(responseData => responseData)
        .catch(error => error)
}